export default __webpack_public_path__ + "static/swatches_w.6649b6f183ff3dd4758d2602a39c4d39.png";